import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee93278c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["portal-home-state", `${_ctx.config}`])
  }, [
    (_ctx.config === 'IN_PROGRESS')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "进行中"))
      : _createCommentVNode("", true),
    (_ctx.config === 'COMPLETE')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "已结束"))
      : _createCommentVNode("", true),
    (_ctx.config === 'EXPIRED')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "已过期"))
      : _createCommentVNode("", true),
    (_ctx.config === 'FROZEN')
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已冻结"))
      : _createCommentVNode("", true),
    (_ctx.config === 'TOP')
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "置顶"))
      : _createCommentVNode("", true)
  ], 2))
}